
// Initilise the Supplier Tender Editor page
var TECL_TenderSupplierProposalInfo = {

    // Initialise the page
    Initialise: function() {

        TECL_TenderSupplierEditor.RemoveAllTempQuestionFiles();
    }
}